import React from "react";
import Box from "@mui/material/Box";
import {FaIconProps} from "@/types/general";


export default function FaIcon({
                                   onClick,
                                   faIcon,
                                   lighter = false,
                                   fontSize = 14,
                                   color = 'inherit',
                                   variant = 'regular',
                                   justifyContent = 'center',
                                   alignItems = 'center',
                                   sx,
                                   spaceStart,
                                   spaceEnd,
                                   strokeWidth = '0',
                                   strokeColor = 'currentColor',
                               }: FaIconProps) {
    const variantMap = {
        'light': 'fal',
        'regular': 'far',
        'solid': 'fas',
        'brands': 'fab',
    }

    const strokeStyle = strokeWidth !== '0' ? {
        WebkitTextStrokeWidth: strokeWidth,
        WebkitTextStrokeColor: strokeColor,
        paintOrder: 'stroke fill',
    } : {};

    return (
        <Box
            width = {fontSize}
            height = {fontSize}
            display = 'inline-flex'
            justifyContent = {justifyContent}
            alignItems = {alignItems}
            onClick = {onClick}
            component = 'span'
            sx = {{
                color: color,
                mr: spaceEnd ? 1 : 0,
                ml: spaceStart ? 1 : 0,
                '& i': {
                    fontWeight: lighter ? variant === 'regular' ? 350 : null : null,
                    fontSize: fontSize,
                    ...strokeStyle,
                },
                ...sx,
            }}
        >
            <i className = {`${variantMap[variant]} ${faIcon}`} />
        </Box >
    )
}